const dedupeChatItemsByRoomId = (items = []) => {
  if (!Array.isArray(items)) {
    return [];
  }

  const dedupedItems = [];
  const itemIndexByKey = new Map();

  items.forEach((item) => {
    const dedupeKey = item?.roomId ?? item?._id;

    if (dedupeKey === undefined || dedupeKey === null) {
      dedupedItems.push(item);
      return;
    }

    const normalizedKey = String(dedupeKey);
    const existingIndex = itemIndexByKey.get(normalizedKey);

    if (existingIndex !== undefined) {
      dedupedItems[existingIndex] = item;
      return;
    }

    itemIndexByKey.set(normalizedKey, dedupedItems.length);
    dedupedItems.push(item);
  });

  return dedupedItems;
};

export default dedupeChatItemsByRoomId;